import { app } from '@lib';

export default {
  // 会员积分-封杰
  stuMemberScore(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/member-pc/manager/pagePointEntry',
      params,
    });
  },
  // 会员积分合计-封杰
  stuMemberScoreTotal(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/member-pc/manager/getPointSummary',
      params,
    });
  },
  // 获取加减法规则-封杰
  getPresetScoreRule(params) {
    return app.http.ajax({
      method: 'get',
      url: `/api/member-pc/manager/listNotPresetTaskConfig?ruleType=${params.rule}`,
    });
  },
  memberGivePoint(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/member-pc/manager/givePoint',
      params,
    });
  },
  // 导出
  openMemberProduct() {
    return app.http.ajax({
      method: 'post',
      url: '/api/member-pc/manager/openMemberProduct',
    });
  },
};
